/* eslint-disable camelcase */
import React from 'react';
import { Modal } from 'react-responsive-modal';
import { useHistory } from 'react-router-dom';
import Button from '../../../common/Button';
import writerVideo from '../../../assets/img/Writer.mp4';
import IWriterOldModalProps from './props';

const closeIcon = (
  <svg
    width="28"
    height="28"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M6.15234 6.15234C6.46875 5.83594 6.99609 5.83594 7.3125 6.15234L8.96484 7.83984L10.6523 6.15234C10.9688 5.83594 11.4961 5.83594 11.8125 6.15234C12.1641 6.50391 12.1641 7.03125 11.8125 7.34766L10.1602 9L11.8125 10.6523C12.1641 11.0039 12.1641 11.5312 11.8125 11.8477C11.4961 12.1992 10.9688 12.1992 10.6523 11.8477L8.96484 10.1953L7.3125 11.8477C6.99609 12.1992 6.46875 12.1992 6.15234 11.8477C5.80078 11.5312 5.80078 11.0039 6.15234 10.6523L7.80469 9L6.15234 7.34766C5.80078 7.03125 5.80078 6.50391 6.15234 6.15234ZM18 9C18 13.9922 13.957 18 9 18C4.00781 18 0 13.9922 0 9C0 4.04297 4.00781 0 9 0C13.957 0 18 4.04297 18 9ZM9 1.6875C4.95703 1.6875 1.6875 4.99219 1.6875 9C1.6875 13.043 4.95703 16.3125 9 16.3125C13.0078 16.3125 16.3125 13.043 16.3125 9C16.3125 4.99219 13.0078 1.6875 9 1.6875Z"
      fill="black"
    />
  </svg>
);

function WriterOldModal({ open }: IWriterOldModalProps) {
  const history = useHistory();

  return (
    <Modal
      open={open}
      onClose={() => history.push('/browse')}
      closeIcon={closeIcon}
      styles={{ modal: { maxWidth: '700px' } }}
    >
      <div className="p-6">
        <div className="mb-6 text-center">
          <h1 className="font-barlow font-semibold text-4xl">
            Introducing Writer.
          </h1>
          <p className="font-barlow text-lg">Starting at $40 per month.</p>
        </div>
        <video width="100%" autoPlay loop muted playsInline>
          <source src={writerVideo} type="video/mp4" />
          Your browser does not support HTML video.
        </video>
        <div className="my-6">
          <h1 className="font-semibold">
            Writer is a page that writes itself.
          </h1>
          <p>
            Seriously. With minimal inputs you can generate sentences,
            paragraphs, and whole stories in seconds. Write any kind of
            long-form content on different topics, with expert level
            understanding.
          </p>
        </div>
        <Button
          type="primary"
          className="w-full"
          onClick={() => history.push('/plan')}
        >
          Upgrade Today
        </Button>
      </div>
    </Modal>
  );
}

export default WriterOldModal;
